import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleCard from "@/components/feature/ArticleCard";
import SEOHead from "@/components/feature/SEOHead";
import { articles, categories, heroHighlights } from "@/mocks/articles";

export default function Home() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);
  const latestArticles = articles.slice(0, 8);
  const exclusiveArticles = articles.filter((a) => a.isExclusive).slice(0, 3);

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "51每日大赛",
    url: "http://baoliaobao.cn/",
    description: "51每日大赛实时吃瓜爆料与黑料网，覆盖每日大赛今日吃瓜、在线观看入口，追踪网红塌房现场猛料，每日大赛吃瓜黑料不间断更新。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "http://baoliaobao.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "51每日大赛",
    url: "http://baoliaobao.cn/",
    description: "51每日大赛实时吃瓜爆料与黑料网",
    sameAs: ['http://baoliaobao.cn/'],
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "51每日大赛 - 全网吃瓜爆料第一线",
    url: "http://baoliaobao.cn/",
    description: "51每日大赛实时吃瓜爆料与黑料网，覆盖51每日大赛今日吃瓜、在线观看入口，追踪网红塌房现场猛料。",
    inLanguage: "zh-CN",
    isPartOf: {
      "@type": "WebSite",
      name: "51每日大赛",
      url: "http://baoliaobao.cn/",
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "51每日大赛是什么网站？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "51每日大赛是一个专注于每日大赛吃瓜爆料与黑料追踪的娱乐资讯平台，实时更新网红塌房、明星八卦、直播翻车等热门事件，提供51每日大赛今日吃瓜和在线观看入口。",
        },
      },
      {
        "@type": "Question",
        name: "每日大赛吃瓜爆料内容从哪里来？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "每日大赛吃瓜爆料内容来自多渠道收集，包括匿名投稿、平台监测、网友爆料和专业记者追踪，确保每日大赛黑料网的内容丰富性和时效性。",
        },
      },
      {
        "@type": "Question",
        name: "51每日大赛在线观看入口在哪里？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以直接访问51每日大赛官网首页，在热门文章区域即可在线观看最新吃瓜内容。所有爆料内容均支持PC端和移动端在线浏览。",
        },
      },
      {
        "@type": "Question",
        name: "如何向51每日大赛投稿爆料？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过发送邮件至tougao@baoliaobao.cn进行匿名投稿，我们会严格保护爆料人隐私，审核通过后将第一时间发布。",
        },
      },
    ],
  };

  const allSchemas = [websiteSchema, organizationSchema, webPageSchema, faqSchema];

  return (
    <>
      <SEOHead
        title="51每日大赛 | 每日大赛吃瓜爆料与每日大赛黑料网 | 51每日大赛今日吃瓜"
        description="51每日大赛实时吃瓜爆料与黑料网，覆盖51每日大赛今日吃瓜、在线观看入口，追踪网红塌房现场猛料，每日大赛吃瓜黑料不间断更新。每日大赛吃瓜爆料、每日大赛黑料网、51每日大赛今日、51每日大赛在线观看、每日大赛实时吃瓜、网红塌房、吃瓜爆料入口一网打尽。"
        keywords="每日大赛吃瓜爆料,每日大赛黑料网,51每日大赛今日,51每日大赛在线观看,每日大赛实时吃瓜,网红塌房,吃瓜爆料入口"
        canonicalUrl="http://baoliaobao.cn/"
        schema={allSchemas}
      />

      <div className="min-h-screen bg-background-50 font-sans">
        <Navbar />

        {/* Hero Section */}
        <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20abstract%20background%20with%20warm%20amber%20and%20deep%20red%20gradients%20blending%20seamlessly%2C%20dark%20atmospheric%20edges%2C%20soft%20glowing%20light%20streaks%2C%20editorial%20cinematic%20style%2C%20high%20contrast%2C%20luxurious%20texture%2C%20no%20text%20or%20people%2C%20moody%20and%20mysterious%20vibe%2C%20modern%20minimalist%20composition%20with%20organic%20flow&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
              alt="51每日大赛背景"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          </div>

          <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 flex flex-col items-center text-center pt-20">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-fire-line text-primary-300 animate-pulse"></i>
              <span className="text-sm font-label text-primary-200">实时追踪 · 每日更新</span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-4 leading-tight">
              全网爆料吃瓜第一线
            </h1>
            <p className="text-lg md:text-xl text-white/70 mb-8 max-w-2xl">
              追踪 <strong>网红塌房</strong> 现场猛料，深挖 <strong>每日大赛吃瓜爆料</strong> 内幕，
              <strong>51每日大赛今日</strong> 最劲爆黑料一网打尽
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 mb-10">
              <Link
                to="/category/wanghong-tafang"
                className="px-8 py-3.5 bg-primary-500 text-background-50 font-label font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-base flex items-center gap-2"
              >
                <i className="ri-fire-line"></i>
                立即开吃
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 text-white/80 font-label rounded-full hover:text-white hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer text-base"
              >
                了解更多 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>

            {/* Hero Cards */}
            <div className="hidden md:flex items-end justify-center gap-3 w-full">
              {heroHighlights.map((item, index) => {
                const offsets = [
                  "translate-y-0 z-30",
                  "-translate-y-2 z-20",
                  "-translate-y-4 z-10",
                  "-translate-y-2 z-20",
                  "translate-y-0 z-30",
                ];
                return (
                  <Link
                    key={item.slug}
                    to={`/article/${item.slug}`}
                    className={`flex-1 max-w-[180px] p-4 rounded-xl bg-gradient-to-br ${item.color} backdrop-blur-sm border border-white/20 text-left hover:scale-105 transition-all duration-300 cursor-pointer ${offsets[index]}`}
                  >
                    <p className="text-white font-heading font-semibold text-sm leading-tight mb-1 line-clamp-2">
                      {item.title}
                    </p>
                    <p className="text-white/70 text-xs leading-relaxed line-clamp-2">
                      {item.excerpt}
                    </p>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* Category Nav Section */}
        <section className="bg-background-50 py-8 border-b border-background-200">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
              <Link
                to="/"
                className="flex-shrink-0 px-4 py-2 bg-primary-100 text-primary-700 text-sm font-label font-semibold rounded-full whitespace-nowrap cursor-pointer"
              >
                全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex-shrink-0 px-4 py-2 bg-background-100 text-foreground-600 text-sm font-label rounded-full hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className={`${cat.icon} mr-1`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Articles Grid */}
        <section className="py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex items-end justify-between mb-10">
              <div>
                <span className="text-xs font-label text-foreground-500 uppercase tracking-wide">
                  热门追踪
                </span>
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-1">
                  今日热点 · 实时追踪
                </h2>
              </div>
              <Link
                to="/category/yule-mengliao"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-label whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {hotArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>

            <div className="mt-8 flex sm:hidden justify-center">
              <Link
                to="/category/yule-mengliao"
                className="px-6 py-2.5 border border-primary-300 text-primary-600 text-sm font-label rounded-full hover:bg-primary-50 transition-colors cursor-pointer"
              >
                查看全部文章
              </Link>
            </div>
          </div>
        </section>

        {/* Exclusive Articles Section */}
        <section className="py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="mb-10">
              <span className="text-xs font-label text-accent-700 uppercase tracking-wide bg-accent-100 px-3 py-1 rounded-full">
                独家爆料
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-3">
                51独家 · 重磅内幕
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {exclusiveArticles.map((article, index) => (
                <ArticleCard
                  key={article.slug}
                  article={article}
                  variant={index === 0 ? "featured" : "default"}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex items-end justify-between mb-10">
              <div>
                <span className="text-xs font-label text-foreground-500 uppercase tracking-wide">
                  最新爆料
                </span>
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-1">
                  每日更新 · 不重样
                </h2>
              </div>
              <Link
                to="/category/shehui-qiwen"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-label whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20atmospheric%20gradient%20background%20with%20deep%20orange%20and%20burgundy%20tones%2C%20soft%20flowing%20organic%20shapes%2C%20editorial%20cinematic%20style%2C%20dramatic%20lighting%20from%20center%2C%20dark%20edges%2C%20moody%20and%20sophisticated%20aesthetic%2C%20no%20text%20or%20people%2C%20elegant%20minimal%20composition&width=1920&height=800&seq=cta-bg-section&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
          </div>

          <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4">
              瓜田永不眠
            </h2>
            <p className="text-lg text-white/70 mb-8">
              每天都有新瓜上市，关注51每日大赛，不错过任何劲爆内容
            </p>
            <Link
              to="/category/shenye-heiliao"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-secondary-400 text-background-50 font-label font-semibold rounded-full hover:bg-secondary-500 transition-all duration-300 whitespace-nowrap cursor-pointer text-base"
            >
              深夜档猛料
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-6 md:px-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">
              常见问题
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {faqSchema.mainEntity.map((faq: { name: string; acceptedAnswer: { text: string } }, index: number) => (
                <div key={index} className="p-5 rounded-xl bg-background-100 border border-background-200">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                    {faq.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.acceptedAnswer.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}